import React, { useState, useEffect } from 'react';
import { configService } from '../../services';
import './Configuracoes.css';

function Configuracoes() {
  const [empresa, setEmpresa] = useState(null);
  const [delivery, setDelivery] = useState(null);
  const [taxas, setTaxas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('empresa');
  const [savingPag, setSavingPag] = useState(false);

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    setLoading(true);
    try {
      const [empRes, delRes, taxRes] = await Promise.all([
        configService.empresa(),
        configService.configDelivery(),
        configService.taxasCartao()
      ]);
      setEmpresa(empRes.data);
      setDelivery(delRes.data);
      setTaxas(taxRes.data || []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const adicionarTaxa = () => setTaxas([...taxas, { nome: '', taxa: 0 }]);
  const removerTaxa = (i) => setTaxas(taxas.filter((_, idx) => idx !== i));
  const alterarTaxa = (i, campo, valor) =>
    setTaxas(taxas.map((t, idx) => idx === i ? { ...t, [campo]: valor } : t));

  const salvarTaxas = async (e) => {
    e.preventDefault();
    setSavingPag(true);
    try {
      const res = await configService.atualizarTaxasCartao(taxas);
      setTaxas(res.data || []);
      alert('Taxas salvas!');
    } catch (err) { alert('Erro ao salvar'); }
    setSavingPag(false);
  };

  const salvarEmpresa = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await configService.atualizarEmpresa(empresa);
      alert('Dados da empresa salvos!');
    } catch (err) { alert('Erro ao salvar'); }
    setSaving(false);
  };

  const salvarDelivery = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await configService.atualizarConfigDelivery(delivery);
      alert('Configurações de delivery salvas!');
    } catch (err) { alert('Erro ao salvar'); }
    setSaving(false);
  };

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <div className="config-page">
      <h1>Configurações</h1>

      <div className="config-tabs">
        <button className={tab === 'empresa' ? 'active' : ''} onClick={() => setTab('empresa')}>Empresa</button>
        <button className={tab === 'pagamentos' ? 'active' : ''} onClick={() => setTab('pagamentos')}>Pagamentos</button>
        <button className={tab === 'delivery' ? 'active' : ''} onClick={() => setTab('delivery')}>Delivery</button>
      </div>

      {tab === 'empresa' && empresa && (
        <form className="config-form" onSubmit={salvarEmpresa}>
          <div className="form-grid">
            <div className="form-group">
              <label>Razão Social</label>
              <input value={empresa.razao_social || ''} onChange={e => setEmpresa({...empresa, razao_social: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Nome Fantasia</label>
              <input value={empresa.nome_fantasia || ''} onChange={e => setEmpresa({...empresa, nome_fantasia: e.target.value})} />
            </div>
            <div className="form-group">
              <label>CNPJ</label>
              <input value={empresa.cnpj || ''} onChange={e => setEmpresa({...empresa, cnpj: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Telefone</label>
              <input value={empresa.telefone || ''} onChange={e => setEmpresa({...empresa, telefone: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={empresa.email || ''} onChange={e => setEmpresa({...empresa, email: e.target.value})} />
            </div>
            <div className="form-group full">
              <label>Endereço</label>
              <input value={empresa.endereco || ''} onChange={e => setEmpresa({...empresa, endereco: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Cidade</label>
              <input value={empresa.cidade || ''} onChange={e => setEmpresa({...empresa, cidade: e.target.value})} />
            </div>
            <div className="form-group">
              <label>UF</label>
              <input value={empresa.uf || ''} onChange={e => setEmpresa({...empresa, uf: e.target.value})} maxLength={2} />
            </div>
            <div className="form-group">
              <label>CEP</label>
              <input value={empresa.cep || ''} onChange={e => setEmpresa({...empresa, cep: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Inscrição Estadual</label>
              <input value={empresa.inscricao_estadual || ''} onChange={e => setEmpresa({...empresa, inscricao_estadual: e.target.value})} />
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </form>
      )}

      {tab === 'pagamentos' && (
        <form className="config-form" onSubmit={salvarTaxas}>
          <p style={{color:'#666', marginBottom:20, fontSize:14}}>
            Cadastre quantas taxas quiser — uma para cada bandeira ou forma de pagamento
            (ex.: Mastercard Crédito, Visa Débito, Pluxee, PIX). Elas são usadas no simulador
            de precificação do cardápio para mostrar a margem real em cada uma.
          </p>

          <div className="taxas-lista">
            {taxas.length === 0 && (
              <p style={{color:'#999', fontSize:13, marginBottom:12}}>Nenhuma taxa cadastrada ainda.</p>
            )}
            {taxas.map((t, i) => (
              <div key={i} className="taxa-linha">
                <input
                  type="text"
                  placeholder="Nome (ex.: Mastercard Crédito)"
                  value={t.nome || ''}
                  onChange={e => alterarTaxa(i, 'nome', e.target.value)} />
                <div className="taxa-percent">
                  <input
                    type="number" step="0.01" min="0" max="100"
                    value={t.taxa ?? 0}
                    onChange={e => alterarTaxa(i, 'taxa', e.target.value)} />
                  <span>%</span>
                </div>
                <button type="button" className="btn-remover-taxa" onClick={() => removerTaxa(i)} title="Remover">✕</button>
              </div>
            ))}
          </div>

          <button type="button" className="btn btn-secondary" onClick={adicionarTaxa} style={{marginBottom:16}}>
            + Adicionar taxa
          </button>

          <div style={{background:'#fff8e6', border:'1px solid #ffe4a0', borderRadius:8, padding:'12px 16px', marginBottom:20, fontSize:13, color:'#a06000'}}>
            💡 Essas taxas ficam visíveis como simulador na tela de <strong>Cardápio → Produtos</strong> ao editar qualquer produto.
          </div>
          <button type="submit" className="btn btn-primary" disabled={savingPag}>
            {savingPag ? 'Salvando...' : 'Salvar taxas'}
          </button>
        </form>
      )}

      {tab === 'delivery' && (
        <form className="config-form" onSubmit={salvarDelivery}>
          <div className="form-grid">
            <div className="form-group">
              <label>Taxa de Entrega (R$)</label>
              <input type="number" step="0.01" value={delivery?.taxa_entrega || ''} onChange={e => setDelivery({...delivery, taxa_entrega: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Pedido Mínimo (R$)</label>
              <input type="number" step="0.01" value={delivery?.pedido_minimo || ''} onChange={e => setDelivery({...delivery, pedido_minimo: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Raio de Entrega (km)</label>
              <input type="number" step="0.1" value={delivery?.raio_entrega_km || ''} onChange={e => setDelivery({...delivery, raio_entrega_km: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Tempo Estimado (min)</label>
              <input type="number" value={delivery?.tempo_estimado_min || ''} onChange={e => setDelivery({...delivery, tempo_estimado_min: e.target.value})} />
            </div>
            <div className="form-group">
              <label>
                <input type="checkbox" checked={delivery?.ativo || false} onChange={e => setDelivery({...delivery, ativo: e.target.checked})} />
                {' '}Delivery Ativo
              </label>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </form>
      )}
    </div>
  );
}

export default Configuracoes;
